import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const travelBargainSettingsEntity: Entity = {
  model: model,
  repository: repository,
}

export default travelBargainSettingsEntity
